import { Pagination as PaginationAntd, PaginationProps as PaginationPropsAntd } from 'antd'

import './Pagination.scss'

interface PaginationProps extends PaginationPropsAntd {}

export const Pagination = (props: PaginationProps) => {
  return <PaginationAntd {...props} />
}
